export default __webpack_public_path__ + "static/media/Work_order_Filled_Active.864625ad.svg";